import React from "react";
import { Navbar } from "../Navbar/Navbar";
import { NotificationsDrawer } from "Components/NotificationsDrawer/NotificationsDrawer";
import { NotificationsModal } from "Components/NotificationsModal/NotificationsModal";
import { Tutorial } from "Components/Tutorial/Tutorial";
import { RegisterDrawer } from "Components/RegisterDrawer/RegisterDrawer";
import { LoginDrawer } from "Components/LoginDrawer/LoginDrawer";
import { NuevasCapacitacionesPresenciales } from "Components/NuevasCapacitacionesPresenciales/NuevasCapacitacionesPresenciales";
import "./Layout.scss";

/**
 * Layout component que provee la estructura principal de la aplicación.
 * Incluye el navbar sticky y el contenido principal.
 *
 * @param {Object} props - Las props del componente
 * @param {React.ReactNode} props.children - El contenido que se renderizará en el área principal
 * @returns {JSX.Element} Estructura de layout con navbar y contenido principal
 */
export const Layout = ({ children }) => {
  return (
    <div className="layout">
      <Navbar />
      <NotificationsDrawer />
      <NotificationsModal />
      <RegisterDrawer />
      <LoginDrawer />
      <main className="layout__content">{children}</main>
      <Tutorial />
      <NuevasCapacitacionesPresenciales />
    </div>
  );
};
